import {
    Icon,
    IconButton
} from '@mui/material';
import { MRT_ColumnDef } from 'material-react-table';
import { useEffect, useMemo, useState } from 'react';
import { Route, Routes, useNavigate, useParams } from 'react-router-dom';
import { TABLE_FILTER } from '../../../_const/tableFilter.const';
import { handleErrorResponse } from '../../../_helpers/handleResponse.helper';
import { clientContactService } from '../../../_services/clientContact.service';
import { StandardTablePanel } from '../../../_components/panel/standardTable.panel';
import { ClientContactManageDrawer } from './client-contactManageDrawer';



export const ClientContactPanel = () => {
    const { clientId } = useParams<{ clientId: string }>();
     const [data, setData] = useState<any>({ items: [], count: 0 });
    const [filter, setFilter] = useState<any>({ ...TABLE_FILTER, pageSize: "10", orderBy: "" });
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();

     const fetchData = () => {
        if (!clientId) return;
        setIsLoading(true);
         return clientContactService.getAll(clientId, filter)
             .then(setData)
             .catch(handleErrorResponse)
             .finally(() => setIsLoading(false));
    };

    useEffect(()=>{
        fetchData();
    }, [clientId])

    const columns = useMemo<MRT_ColumnDef<any>[]>(
        () => [
            {
                id: 'actions',
                header: '',
                size: 5,
                enableSorting: false,
                enableColumnFilter: false,
                enableColumnActions: false,
                Cell: ({ row }) => (
                    <IconButton
                        color="primary"
                        onClick={() => { navigate("Contact/Manage/" + row.original.id) }}>
                        <Icon>edit</Icon>
                    </IconButton>
                ),
            },
            {
                accessorKey: 'clientContactTypeName',
                header: 'Contact Type',
                enableSorting: false,
                enableColumnFilter: false,
                enableColumnActions: false,
            },
            {
                accessorKey: 'name',
                header: 'Name',
                enableSorting: false,
                enableColumnFilter: false,
                enableColumnActions: false,
            },
            {
                accessorKey: 'phone',
                header: 'Phone',
                enableSorting: false,
                enableColumnFilter: false,
                enableColumnActions: false,
            },
            {
                accessorKey: 'mobilePhone',
                header: 'Mobile',
                enableSorting: false,
                enableColumnFilter: false,
                enableColumnActions: false,
            },
            {
                accessorKey: 'email',
                header: 'Email',
                enableSorting: false,
                enableColumnFilter: false,
                enableColumnActions: false,
            },
        ],
        []
    );

    return (
        <>
            <StandardTablePanel
                title="Contacts"
                buttons={[
                    { icon: "add", onClick: () => { navigate("Contact/Create"); } },
                ]}

                columns={columns}
                data={data}
                filter={filter}
                setFilter={setFilter}
                loading={isLoading}
            />


            <Routes>
                <Route path="Contact/Create" element={<ClientContactManageDrawer clientId={clientId!} onSave={() => { navigate(""); fetchData(); }} onClose={() => { navigate("") }} />} />
                <Route path="Contact/Manage/:id" element={<ClientContactManageDrawer clientId={clientId!} onSave={() => { navigate(""); fetchData(); }} onClose={() => { navigate("") }} />} />
            </Routes>

        </>
    );
};